import React from 'react';
import { Avatar, Dropdown, Menu, Space, Typography } from 'antd';
import { i18n } from '@/core';
import { useGettext } from '@cranium/i18n';
import { useHistory } from '@/shared/navigation';
import { useMeMember } from '@/core/gql/helpers/hooks';
import { BackgroundOrdersJobService } from '@/core/gql/apollo';
import { LocalStorage } from '@/core/Storage';
import { get } from 'lodash';
import { usePermissions } from '@/shared/access';
import styled from 'styled-components';

const MenuStyled = styled(Menu)`
  max-width: 150px;
  margin-left: auto !important;
`;

const MemberInfoMenu = () => {
  const permissions = usePermissions();
  const { gettext } = useGettext();
  const history = useHistory();
  const member = useMeMember();

  const { pathname } = history.location;
  const { managerName, avatar } = member ?? {};
  const nameInitial = managerName?.split('')[0]?.toUpperCase() ?? 'N/A';

  const menuItems = [
    {
      label: (
        <Space>
          <span className="ant-icon icon-user gray-7" />
          <Typography className="regular-14 gray-10">{i18n.t('labels.profile')}</Typography>
        </Space>
      ),
      key: 'profile',
      permission: 'profile.show',
      onClick: () => pathname !== '/profile' && history.push('/profile')
    },
    {
      label: (
        <Space>
          <span className="ant-icon icon-logout gray-7" />
          <Typography className="regular-14 gray-10">{i18n.t('labels.logout')}</Typography>
        </Space>
      ),
      key: 'logout',
      onClick: () => {
        LocalStorage.clearAll();
        BackgroundOrdersJobService.stopWatch();
      }
    }
  ].filter(item => !item?.permission || get(permissions, item.permission));

  return (
    <Dropdown className="cursor-pointer" overlay={<MenuStyled items={menuItems} />} trigger={['click']}>
      <Space align="center" aria-label={gettext('Profile menu')} role="button">
        <Typography className="bold-14 gray-10">{managerName}</Typography>
        {avatar ? <Avatar size={24} src={avatar} /> : <Avatar size={24}>{nameInitial}</Avatar>}
        <Typography className="icon-down gray-5 regular-24" />
      </Space>
    </Dropdown>
  );
};

export default MemberInfoMenu;
